export default {
  "content": "<title>Desktop</title><rect x=\"32\" y=\"64\" width=\"448\" height=\"320\" rx=\"32\" ry=\"32\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M304 448l-8-64h-80l-8 64h96z\" class=\"ionicon-stroke-width\"/><path d=\"M368 448H144\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M32 304v48a32.09 32.09 0 0032 32h384a32.09 32.09 0 0032-32v-48zm224 64a16 16 0 1116-16 16 16 0 01-16 16z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};